import {put, takeLatest, call} from 'redux-saga/effects';
import * as configActions from '../../player/actions/config.actions';
import {API} from '~/utils/request';

function convertObjectToStrDotNotation(data, currPath = '', out = {}) {
  const isObject = typeof data === 'object' && data !== null;
  const dataCpy = data;
  const outCpy = out;

  // get all properties of the object recursively
  // the keys should be the stringified dot notation
  // and the values should be the corresponding value
  if (isObject) {
    const keysForObject = Object.getOwnPropertyNames(dataCpy);

    // eslint-disable-next-line unicorn/no-for-loop
    for (let keyIdx = 0; keyIdx < keysForObject.length; keyIdx += 1) {
      const key = keysForObject[keyIdx];
      const value = dataCpy[key];
      const pathForKey = currPath === '' ? key : `${currPath}.${key}`;

      convertObjectToStrDotNotation(value, pathForKey, out);
      outCpy[pathForKey] = value;
    }

    return outCpy;
  }
  // we have reached the bottom of the recursion, just return the data

  return dataCpy;
}

const findObjectByKeyAndValue = (obj, key, value) => {
  const isObject = typeof obj === 'object' && obj !== null;

  if (isObject) {
    const keysForObject = Object.getOwnPropertyNames(obj);

    // eslint-disable-next-line unicorn/no-for-loop
    for (let keyIdx = 0; keyIdx < keysForObject.length; keyIdx += 1) {
      const currKey = keysForObject[keyIdx];
      const currValue = obj[currKey];

      if (currKey === key && currValue === value) {
        return obj;
      }

      const found = findObjectByKeyAndValue(currValue, key, value);

      if (found) {
        return found;
      }
    }
  }

  return null;
};

function* getConfig() {
  yield put(configActions.configGetConfigRequest());
  try {
    let config = yield call(API.getConfig, 'editor');
    const recievedValidJSON = typeof config === 'object' && config !== null;

    if (recievedValidJSON) {
      /* find all the keys using a stringified dot-notation and store them in this manner
      so if we have this config-object:
      {
        a: {a1: 123, a2: 456}, b: {b1: true} }
      }

      create this:
      {
        a: {a1: 123, a2: 456},
        b: {b1: {b2: true}},
        'a.a1': 123,
        'a.a2': 456,
        'b.b1': true,
      }

      in this way, we can easily and efficiently access a specific property in the config using this syntax,
      so if we want to get a -> a1 we just look up 'a.a1' in the config
      */

      const configDataInDotNotation = convertObjectToStrDotNotation(config);

      // temp hack for new bulletpoints template (replace with html string with <ul> and <li> tags instead of \n)
      const bulletpointsTemplate = findObjectByKeyAndValue(config, 'unorderedList', true);

      if (bulletpointsTemplate?.text && !bulletpointsTemplate.text.includes('<ul>')) {
        bulletpointsTemplate.text = `<ul><li>${bulletpointsTemplate.text.replaceAll('\n', '</li><li>')}</li></ul>`;
      }

      config = configDataInDotNotation;
    } else {
      console.error('Invaldid JSON for config-file');
      console.log('invalid json!');
    }

    API.config = config;

    yield put(configActions.configGetConfigSuccess({config}));
  } catch (error) {
    console.error(error);
    yield put(configActions.configGetConfigFailure({error}));
  }
}

export const sagas = [takeLatest(configActions.CONFIG_GET_CONFIG, getConfig)];
